<template>
    <div class="modal fade detail-boat" :id="idModalBoatGallery" tabindex="-1" role="dialog" aria-labelledby="myLargeModal" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{verifyShip ? 'EMBARCACION':''}} {{ nameShip }} </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="row">
                    <div class="modal-body image-carousel col ">
                        <div id="carouselExampleIndicators" class="carousel slide" data-interval="false">
                            <ol class="carousel-indicators">

                                <li data-target="#carouselExampleIndicators" v-for="(p, index) in photos" :key="index" :data-slide-to="index" :class="{'active': (p.image_principal===1 ||index===0 ) }"></li>

                            </ol>
                            <div class="carousel-inner">
                                <div class="carousel-item" v-for="(p, index) in photos" :key="p.id" :class=" {'active': (p.image_principal===1 ||index===0 ) }">
                                    <img :src="p.path" class="d-block w-100">
                                <div class="carousel-caption d-none d-md-block">
                                    <h5>{{ p.title }}</h5>
                                </div>
                                </div>
                            </div>
                            <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span class="sr-only">Previous</span>
                            </a>
                            <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                <span class="sr-only">Next</span>
                            </a>
                        </div>       
                        
                    </div> 
                </div>

                <div class="modal-footer">                    
                    <button type="button" class="btn btn-outline-danger" data-dismiss="modal"><font-awesome-icon icon="times-circle" size="lg" /></button>                        
                </div>
            </div>
        </div>            
    </div>
</template>
<script>
import Vue from 'vue';
import axios from 'axios';
const qs = require('qs');

export default {
    name:'modal-photos-boat',
    props:{
        photos:Array,
        idModalBoatGallery:String,
        nameShip:String,
        verifyShip:{
            type:Boolean,
            default:true
        }
    },
    computed:{
        
    }
}
</script>
<style>
/* .image-carousel{
    width: 1080px;
} */

.carousel-inner > .item > img {
  object-fit: scale-down;
  height: 50vh;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/verify/ModalPhotosBoat.vue